// How to add more Icons:
// upload svg to custom_icons directory
// edit svg so path contains the attrabute fill="currentColor" and width and height are not set
// create export in here for that svg
// go to TTCore/icon.tsx
// add exported name 'RoundStarIcon' to import
// add to the NewIcon cases 

export { default as RoundStarIcon } from './roundStarIcon.svg';

